import { io, type Socket } from "socket.io-client";
import type { ClientToServerEvents, ServerToClientEvents } from "@foto/shared";

export type AppSocket = Socket<ServerToClientEvents, ClientToServerEvents>;

let socket: AppSocket | null = null;

/**
 * Conexão única, criada sob demanda.
 *
 * O tempo real aqui é **conveniência, não dependência**: toda tela que escuta
 * socket também refaz a consulta por conta própria. No sistema anterior a tela
 * de geração tinha `refetchInterval: false` e dependia só do socket — se ele
 * caísse, o operador ficava olhando "processando" para sempre, sem saber que já
 * tinha acabado.
 */
export function obterSocket(): AppSocket {
  socket ??= io({
    transports: ["websocket", "polling"],
    reconnectionDelay: 500,
    reconnectionDelayMax: 5_000,
  });
  return socket;
}
